var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex gap-5"},_vm._l((_vm.range),function(val){return _c('app-button',{key:val,staticClass:"flex",class:[val != _vm.value ? 'opacity-50' : ''],attrs:{"color":val != _vm.value ? 'darkgreen' : 'darkgreen'},on:{"click":function($event){return _vm.$emit('input', val)}}},[_vm._v("\n            "+_vm._s(val
                    ? _vm.$t("reservations.review.yes")
                    : _vm.$t("reservations.review.no"))+"\n        ")])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }